import { t } from '@/locale/index.js'

const COLUMN_KEYS = {
  id: 'personnelList.colId',
  real_name: 'personnelList.colName',
  english_name: 'personnelList.colEnglishName',
  id_card: 'personnelList.colIdCard',
  sex: 'personnelList.colSex',
  username: 'personnelList.colUsername',
  password: 'personnelList.colPassword',
  email: 'personnelList.colEmail',
  address: 'personnelList.colAddress',
  start_date: 'personnelList.colStartDate',
  end_date: 'personnelList.colEndDate',
  employment: 'personnelList.colEmployment',
  mobile: 'personnelList.colMobile',
  points: 'personnelList.colPoints',
  status: 'personnelList.colStatus',
  login_time: 'personnelList.colLoginTime',
  operation: 'personnelList.colOperation',
}

/** 队长/机手列表页：搜索、表头、选项文案 */
export function applyPersonnelListLabels({
  searchData,
  columns,
  employmentOptions,
  sexOptions,
  statusOptions,
  roleOptions,
  role = 'captain',
}) {
  if (searchData?.[0]) {
    searchData[0].label =
      role === 'captain' ? t('personnelList.captainSearch') : t('personnelList.machinistSearch')
    searchData[0].placeholder = t('personnelList.searchPlaceholder')
  }
  const roleField = searchData?.find((item) => item.field === 'role_id')
  if (roleField) {
    roleField.label = t('field.role')
  }
  if (roleOptions?.length >= 3) {
    roleOptions[0].label = t('common.all')
    roleOptions[1].label = t('personnelList.roleMachinist')
    roleOptions[2].label = t('personnelList.roleCaptain')
  }
  columns?.forEach((col) => {
    if (col.type === 'index') {
      col.label = t('personnelList.colIndex')
      return
    }
    if (col.prop === 'id' && role === 'captain') {
      col.label = t('personnelList.colCaptainId')
      return
    }
    if (col.prop && COLUMN_KEYS[col.prop]) {
      col.label = t(COLUMN_KEYS[col.prop])
    }
  })
  if (employmentOptions?.length) {
    employmentOptions[0].label = t('personnelList.employmentActive')
    employmentOptions[1].label = t('personnelList.employmentInactive')
  }
  if (sexOptions?.length >= 3) {
    sexOptions[0].label = t('personnelList.sexUnknown')
    sexOptions[1].label = t('personnelList.sexMale')
    sexOptions[2].label = t('personnelList.sexFemale')
  }
  if (statusOptions?.length >= 2) {
    statusOptions[0].label = t('personnelList.statusDisabled')
    statusOptions[1].label = t('personnelList.statusEnabled')
  }
}

export function personnelListT(role = 'captain') {
  return {
    linkMachinist: t('personnelList.linkMachinist'),
    bindTitle: t('personnelList.linkMachinist'),
    edit: t('common.edit'),
    resetPwd: t('personnelList.resetPwd'),
    detail: t('common.detail'),
  }
}
